export default __webpack_public_path__ + "static/media/Background_00079.badb53fe.png";